import { ArrowDownLeftIcon } from 'lucide-react';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  Heading,
} from '@/components/atoms';

interface SummaryCardsProps {
  totalAmount: string;
  pendingAmount: string;
}

export const SummaryCards = ({
  totalAmount,
  pendingAmount,
}: SummaryCardsProps) => {
  return (
    <div className="grid max-w-xl grid-cols-1 gap-4 md:grid-cols-2">
      <Card className="bg-primary gap-0 border-none text-white shadow-none">
        <CardHeader className="flex flex-row items-start justify-between space-y-0">
          <CardTitle className="text-sm font-normal text-white">
            Total Online Transactions
          </CardTitle>
          <span className="flex h-8 w-8 items-center justify-center rounded-full bg-white">
            <ArrowDownLeftIcon className="h-4 w-4 text-primary" />
          </span>
        </CardHeader>
        <CardContent>
          <Heading level={1} className="!text-2xl font-bold text-white">
            {totalAmount}
          </Heading>
        </CardContent>
      </Card>

      <Card className="gap-0 border-none bg-muted shadow-none">
        <CardHeader>
          <CardTitle className="text-sm font-normal text-muted-foreground">
            Pending Settlement
          </CardTitle>
        </CardHeader>
        <CardContent>
          <Heading level={2} className="!text-2xl font-bold">
            {pendingAmount}
          </Heading>
        </CardContent>
      </Card>
    </div>
  );
};
